import React from "react";
import {
    Navigate,
} from "react-router-dom";

const PlanListComponent = React.lazy(() => import("../../../../../components/plan/components/list/page"));
const PlanAddComponent = React.lazy(() => import("../../../../../components/plan/components/add/page"));

export const planRoutes = [
    {
        path: 'list',
        element: <PlanListComponent />
    },
    {
        path: 'add',
        element: <PlanAddComponent />
    },
    {
        path: 'edit',
        element: <Navigate to="/administration/plans/add" />
    },
    {
        path: 'edit/:id',
        element: <PlanAddComponent />
    },
    {
        path: '',
        element: <Navigate replace to="/administration/plans/list" />
    },
];